module.exports = __webpack_public_path__ + "static/eye-of-perception-fe9ef49de611a644872a0cbf64f969e6.png";